import { Box, Grid, Skeleton } from '@mui/material';
import { sliderStyles } from './styles';

export const SliderItemSkeleton: React.FC = () => {
  return (
    <Box sx={sliderStyles.container}>
      <Grid
        container
        justifyContent="space-between"
        direction={{ xs: 'column-reverse', md: 'row' }}
        alignItems={{ md: 'center' }}
        spacing={2.5}
      >
        <Grid item xs={12} md={6} xl={5}>
          <Box sx={sliderStyles.contentContainer}>
            <Skeleton variant="rectangular" height="2.5rem" width="100%" />
            <Skeleton sx={{ mt: 1 }} variant="rectangular" height="2.5rem" width="50%" />
            <Box sx={{ mt: 4 }}>
              <Skeleton width="80%" />
              <Skeleton width="80%" />
              <Skeleton width="50%" />
            </Box>
            <Box sx={{ mt: 6 }}>
              <Skeleton variant="rectangular" width="7.5rem" height="2.5rem" />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={5} xl={4}>
          <Box sx={sliderStyles.imageContainer}>
            <Skeleton variant="rectangular" width="100%" height="30rem" />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
